import "./App.css";
import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import loaderGif from './assets/images/layout/spinner.gif';
import BmiCalculator from "./comon/BmiCalculator";
import HealthTips from "./components/Pages/health/HealthTips";
import Anxienty from "./components/Pages/category/yoga/subyoga/Anxienty";
import BackPain from "./components/Pages/category/yoga/subyoga/BackPain";
import BloodPresure from "./components/Pages/category/yoga/subyoga/BloodPresure";
import Posture from "./components/Pages/category/yoga/subyoga/Posture";
import Digestion from "./components/Pages/category/yoga/subyoga/Digestion";
import HeadAche from "./components/Pages/category/yoga/subyoga/HeadAche";
import Anulom from "./components/Pages/category/yoga/partials/Anulom";
import Padangusthasana from "./components/Pages/category/yoga/partials/Padangusthasana";
import Balasana from "./components/Pages/category/yoga/partials/Balasana";
import Dhanurasana from "./components/Pages/category/yoga/partials/Dhanurasana";
import Trikonasana from "./components/Pages/category/yoga/partials/Trikonasana";
import Gomukhasana from "./components/Pages/category/yoga/partials/Gomukhasana";
import Tadasana from "./components/Pages/category/yoga/partials/Tadasana";
import Natarajasana from "./components/Pages/category/yoga/partials/Natarajasana";
import Vyaghrasana from "./components/Pages/category/yoga/partials/Vyaghrasana";
import Naukasana from "./components/Pages/category/yoga/partials/Naukasana";
import Authguard from "./utils/Authguard";
import Inprogress from "./components/Layout/Inprogress";
import Unsubscript from "./components/Layout/Unsubscript";
import Unauthorized from "./components/Layout/Unauthorized";
import Login from "./components/Auth/Login";
import OtpScreen from "./components/Auth/OtpScreen";
import LowBalance from "./components/Layout/LowBalance";
import TechnicalError from "./components/Layout/TechnicalError";


const Onboard = React.lazy(() => import("./components/Onboarding/Index"));
const Home = React.lazy(() => import("./components/Pages/Home/Index"));
const Exercise = React.lazy(()=> import("./components/Pages/category/Index"));
const SubCategory =React.lazy(()=> import("./components/Pages/category/subcategory/Index"));
const Russiantwist = React.lazy(()=> import("./components/Pages/details/RussianTwist"));
const Subscription = React.lazy(()=>import("./components/Pages/subscription/Subscription"));
const Yoga = React.lazy(()=>import("./components/Pages/category/yoga/Yoga"));
const Abdominal = React.lazy(()=> import("./components/Pages/category/yoga/partials/Abdominal"));
const SubYoga = React.lazy(()=> import('./components/Pages/category/yoga/subyoga/SubYoga'));
const Meditation = React.lazy(()=>import("./components/Pages/category/meditation/Meditation"))
const Mindfulness = React.lazy(()=>import("./components/Pages/category/meditation/partials/Mindfulness"));
const Chakra = React.lazy(()=>import("./components/Pages/category/meditation/partials/Chakra"));
const Zumba = React.lazy(()=> import('./components/Pages/category/zumba/Zumba'))
const ZumbaFintess = React.lazy(()=> import('./components/Pages/category/zumba/partials/ZumbaFintess'));
const ZumbaTonning = React.lazy(()=> import('./components/Pages/category/zumba/partials/ZumbaTonning'));
const TermsConditon = React.lazy(()=> import("./components/Pages/Terms&condition/TermsCondition"));
const Faq = React.lazy(()=> import("./components/Pages/FAQ/Faq"));
const LegRaise = React.lazy(()=> import("./components/Pages/details/abs-exercises/LegRaise"));
const AbsMat = React.lazy(()=> import("./components/Pages/details/abs-exercises/AbsMat"));
const AbdominalCrunches = React.lazy(()=> import("./components/Pages/details/abs-exercises/AbdominalCrunches"));
const AirBike = React.lazy(()=> import("./components/Pages/details/abs-exercises/AirBike"));
const AssistedSitUps = React.lazy(()=> import("./components/Pages/details/abs-exercises/AssistedSitUps"));
const Shoulder = React.lazy(()=> import("./components/Pages/category/subcategory/Shoulder/Index"));
const ArmCircle = React.lazy(()=> import("./components/Pages/details/shoulder-exercise/ArmCircle"));
const BackhandRaise = React.lazy(()=> import("./components/Pages/details/shoulder-exercise/BackhandRaise"));
const MilitaryPress = React.lazy(()=> import("./components/Pages/details/shoulder-exercise/MilitaryPress"));
const BodyWeight = React.lazy(()=> import("./components/Pages/details/shoulder-exercise/BodyWeight"));
const Cobra = React.lazy(()=> import("./components/Pages/details/shoulder-exercise/Cobra"));
const Chest = React.lazy(()=> import("./components/Pages/category/subcategory/Chest/Index"));
const Archer = React.lazy(()=> import("./components/Pages/details/chest-exercise/Archer"));
const KneelPushUp = React.lazy(()=> import("./components/Pages/details/chest-exercise/KneelPushUp"));
const StandingFly = React.lazy(()=> import("./components/Pages/details/chest-exercise/StandingFly"));
const Svend = React.lazy(()=> import("./components/Pages/details/chest-exercise/Svend"));
const ChestDip = React.lazy(()=> import("./components/Pages/details/chest-exercise/ChestDip"));
const BackComponent = React.lazy(()=> import("./components/Pages/category/subcategory/Back/Index"));
const ArcherSuperMan = React.lazy(()=> import("./components/Pages/details/back-exercise/ArcherSuperMan"));
const Biceps = React.lazy(()=> import("./components/Pages/category/subcategory/Biceps/Index"));
const AlternateBiceps = React.lazy(()=> import("./components/Pages/details/biceps/AlternateBiceps"));
const AlternateHammer = React.lazy(()=> import("./components/Pages/details/biceps/AlternateHammer"));
const BicepCurl = React.lazy(()=> import("./components/Pages/details/biceps/BicepCurl"));
const Concentration = React.lazy(()=> import("./components/Pages/details/biceps/Concentration"));
const ResistanceBand = React.lazy(()=> import("./components/Pages/details/biceps/ResistanceBand"));
const SeatedBumbell = React.lazy(()=> import("./components/Pages/details/biceps/SeatedBumbell"));
const Leg = React.lazy(()=> import("./components/Pages/category/subcategory/Leg/Index"));
const Sprinter = React.lazy(()=> import("./components/Pages/details/legs/Sprinter"));
const StepOut = React.lazy(()=> import("./components/Pages/details/legs/StepOut"));
const StepBack = React.lazy(()=> import("./components/Pages/details/legs/StepBack"));
const BirdDog = React.lazy(()=> import("./components/Pages/details/legs/BirdDog"));
const PulseSquat = React.lazy(()=> import("./components/Pages/details/legs/PlusSquat"));
const CalfRaise = React.lazy(()=> import("./components/Pages/details/legs/CalfRaise"));
const ArcherPullUp = React.lazy(()=> import("./components/Pages/details/back-exercise/ArcherPullUp"));
const BackExtension = React.lazy(()=> import("./components/Pages/details/back-exercise/BackExtension"));
const BackSqueeze = React.lazy(()=> import("./components/Pages/details/back-exercise/BackSqueeze"));
const SupermanHold = React.lazy(()=> import("./components/Pages/details/back-exercise/SupermanHold"));
const Chakki = React.lazy(()=> import("./components/Pages/category/yoga/partials/Chakki"));

function App() {
  return (
    <Suspense fallback={<div className="loader"><img src={loaderGif} alt="" /></div>}>
      <div className="container">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Onboard />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/home" element={<Authguard><Home /></Authguard>} />
            <Route path="/exercise" element={<Authguard><Exercise /></Authguard>} />
            <Route path="/yoga" element={<Authguard><Yoga /></Authguard>} />
            <Route path="/subcategory" element={<Authguard><SubCategory /></Authguard>} />
            <Route path="/subyoga" element={<Authguard><SubYoga /></Authguard>} />
            <Route path="/russiantwist" element={<Authguard><Russiantwist /></Authguard>} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/absyoga" element={<Authguard><Abdominal /></Authguard>} />
            <Route path="/meditation" element={<Authguard><Meditation /></Authguard>} />
            <Route path="/mindfulness" element={<Authguard><Mindfulness /></Authguard>} />
            <Route path="/chakra" element={<Authguard><Chakra /></Authguard>} />
            <Route path="/zumba" element={<Authguard><Zumba /></Authguard>} />
            <Route path="/zumba-fitness" element={<Authguard><ZumbaFintess /></Authguard>} />
            <Route path="/zumba-tonning" element={<Authguard><ZumbaTonning /></Authguard>} />
            <Route path="/terms-conditions" element={<Authguard><TermsConditon/></Authguard>} />
            <Route path="/faq" element={<Authguard><Faq/></Authguard>} />
            <Route path="/bmi" element={<Authguard><BmiCalculator/></Authguard>} />
            <Route path="/healthTips" element={<Authguard><HealthTips/></Authguard>} />
            <Route path="/leg-raise" element={<Authguard><LegRaise/></Authguard>} />
            <Route path="/absmat" element={<Authguard><AbsMat/></Authguard>} />
            <Route path="/abdominalcrunches" element={<Authguard><AbdominalCrunches/></Authguard>} />
            <Route path="/airbike" element={<Authguard><AirBike/></Authguard>} />
            <Route path="/airbike" element={<Authguard><AirBike/></Authguard>} />
            <Route path="/assistedsitups" element={<Authguard><AssistedSitUps /></Authguard>} />
            <Route path="/shoulder" element={<Authguard><Shoulder/></Authguard>} />
            <Route path="/armcircle" element={<Authguard><ArmCircle/></Authguard>} />
            <Route path="/backhandraise" element={<Authguard><BackhandRaise/></Authguard>} />
            <Route path="/militarypress" element={<Authguard><MilitaryPress/></Authguard>} />
            <Route path="/bodyweight" element={<Authguard><BodyWeight/></Authguard>} />
            <Route path="/cobra" element={<Authguard><Cobra/></Authguard>} />
            <Route path="/chest" element={<Authguard><Chest/></Authguard>} />
            <Route path="/archer" element={<Authguard><Archer/></Authguard>} />
            <Route path="/kneel-push-up" element={<Authguard><KneelPushUp/></Authguard>} />
            <Route path="/standingfly" element={<Authguard><StandingFly/></Authguard>} />
            <Route path="/svend" element={<Authguard><Svend/></Authguard>} />
            <Route path="/chest-dip" element={<Authguard><ChestDip/></Authguard>} />
            <Route path="/back" element={<Authguard><BackComponent/></Authguard>} />
            <Route path="/archer-superman" element={<Authguard><ArcherSuperMan/></Authguard>} />
            <Route path="/archerpullup" element={<Authguard><ArcherPullUp/></Authguard>} />
            <Route path="/backextension" element={<Authguard><BackExtension/></Authguard>} />
            <Route path="/backsqueeze" element={<Authguard><BackSqueeze/></Authguard>} />
            <Route path="/biceps" element={<Authguard><Biceps/></Authguard>} />
            <Route path="/alternatebiceps" element={<Authguard><AlternateBiceps/></Authguard>} />
            <Route path="/alternatecurl" element={<Authguard><AlternateHammer/></Authguard>} />
            <Route path="/supermanhold" element={<Authguard><SupermanHold/></Authguard>} />
            <Route path="/bicepcurl" element={<Authguard><BicepCurl/></Authguard>} />
            <Route path="/concentration" element={<Authguard><Concentration/></Authguard>} />
            <Route path="/resistanceband" element={<Authguard><ResistanceBand/></Authguard>} />
            <Route path="/seateddumbell" element={<Authguard><SeatedBumbell/></Authguard>} />
            <Route path="/leg" element={<Authguard><Leg/></Authguard>} />
            <Route path="/sprinter" element={<Authguard><Sprinter/></Authguard>} />
            <Route path="/stepout" element={<Authguard><StepOut/></Authguard>} />
            <Route path="/stepback" element={<Authguard><StepBack/></Authguard>} />
            <Route path="/birddog" element={<Authguard><BirdDog/></Authguard>} />
            <Route path="/plussquat" element={<Authguard><PulseSquat/></Authguard>} />
            <Route path="/calfraise" element={<Authguard><CalfRaise/></Authguard>} />
            <Route path="/chakki" element={<Authguard><Chakki/></Authguard>} />
            <Route path="/anxienty" element={<Authguard><Anxienty/></Authguard>} />
            <Route path="/backpain" element={<Authguard><BackPain/></Authguard>} />
            <Route path="/bloodpresure" element={<Authguard><BloodPresure/></Authguard>} />
            <Route path="/posture" element={<Authguard><Posture/></Authguard>} />
            <Route path="/digestion" element={<Authguard><Digestion/></Authguard>} />
            <Route path="/headache" element={<Authguard><HeadAche/></Authguard>} />
            <Route path="/anulom" element={<Authguard><Anulom/></Authguard>} />
            <Route path="/padangusthasana" element={<Authguard><Padangusthasana/></Authguard>} />
            <Route path="/balasana" element={<Authguard><Balasana/></Authguard>} />
            <Route path="/dhanurasana" element={<Authguard><Dhanurasana/></Authguard>} />
            <Route path="/trikonasana" element={<Authguard><Trikonasana/></Authguard>} />
            <Route path="/tadasana" element={<Authguard><Tadasana/></Authguard>} />
            <Route path="/gomukhasana" element={<Authguard><Gomukhasana/></Authguard>} />
            <Route path="/natarajasana" element={<Authguard><Natarajasana/></Authguard>} />
            <Route path="/vyaghrasana" element={<Authguard><Vyaghrasana/></Authguard>} />
            <Route path="/naukasana" element={<Authguard><Naukasana/></Authguard>} />
            <Route path="/inprogress" element={<Inprogress/>} />
            <Route path="/unsubscribe" element={<Unsubscript/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/otpscreen" element={<OtpScreen/>} />
            <Route path="/technical-error" element={<TechnicalError/>} />
            <Route path="/low-balance" element={<LowBalance/>} />
          </Routes>
        </BrowserRouter>
      </div>
    </Suspense>
  );
}

export default App;
